import { useState, useRef, useImperativeHandle, forwardRef } from "react";
import ResponsiveImage from "./ResponsiveImage";

const NavBar = forwardRef(({ isWhitened }, ref) => {
  const [whitened, setWhitened] = useState(isWhitened);
  const outerRef = useRef(null);

  useImperativeHandle(ref, () => ({
    handleToggling: (newState) => {
      if (whitened !== newState) {
        setWhitened(newState);
      }
    },
    outerRef: outerRef.current,
  }));

  return (
    <div
      id="navbar"
      role="navigation"
      className={whitened ? "navBar navBarWhite" : "navBar"}
      ref={outerRef}
    >
      <div className="contentWrapper navBarWrapper">
        <a href="/" className="logoLink">
          <ResponsiveImage
            customClassName="spaceImage"
            alt="can_into_space"
            publicURL={process.env.PUBLIC_URL}
            fileName="images/space.png"
          />
        </a>
        <a className="contactLink" href="mailto:contact@caninto.space">
          contact@caninto.space
        </a>
      </div>
    </div>
  );
});

export default NavBar;
